import React, { useEffect, useState } from "react";
import "./KontaktPravnogLica.scss";
import Head from "../modules/Head";
import HeaderComponent from "../components/HeaderComponent";
import Button from "../components/Button";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Cookies from "universal-cookie";
import config from "../config.json";

function KontaktPravnogLica() {
  const { baseUrl, token } = config;
  const params = useParams();
  const navigate = useNavigate();
  const cookies = new Cookies();
  const user = cookies.get("pravnoLice");

  const [ponuda, setPonuda] = useState({});
  const [cijena, setCijena] = useState("000.000");

  useEffect(() => {
    async function getData() {
      try {
        const response = await axios.get(
          `${baseUrl}/pravno/pristigli-zahtjevi/${user.korisnickoIme}`,
          {
            headers: {
              token: token,
              "Content-Type": "application/json",
            },
          }
        );

        setPonuda(response.data[params.id]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    getData();
  }, [params.id, user.korisnickoIme, baseUrl, token]);

  const formik = useFormik({
    initialValues: {
      odogovorInput: "",
      cijenaInput: "",
    },
    validationSchema: Yup.object({
      odogovorInput: Yup.string().required("Niste unijeli odgovor."),
      cijenaInput: Yup.string()
        .required("Niste unijeli cijenu.")
        .matches(
          /^(\d+(?:[.,]\d{1,3})?)$/,
          "Cijena mora biti pozitivan broj sa maksimalno tri decimale."
        )
        .test(
          "is-positive",
          "Cijena mora biti pozitivan broj sa maksimalno tri decimale.",
          (value) => {
            const parsedValue = parseFloat(
              value.replace(",", ".").replace(".", "")
            );
            return !isNaN(parsedValue) && parsedValue > 0;
          }
        ),
    }),
    validateOnChange: true,
    onSubmit: async (values) => {
      if (!ponuda) {
        console.error("Ponuda is null or undefined.");
        return;
      }

      console.log(values);

      const response = await axios.post(
        `${baseUrl}/pravno/odgovori-zahtjevu`,
        {
          korisnik: ponuda.imeFizickogLica,
          imePravnogLica: user.korisnickoIme,
          telefon: user.telefon,
          cijena: values.cijenaInput,
          poruka: ponuda.poruka,
          odgovor: values.odogovorInput,
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );
      const { status } = response;
      console.log(response.data);

      if (status === 200) {
        navigate("/");
      }
    },
  });

  return (
    <form id="kontakt-pravnog-lica" onSubmit={formik.handleSubmit}>
      <Head title="Kontakti Pravnog Lica" />
      <HeaderComponent />
      <h2>Novi zahtjevi za uslugama</h2>
      <ul>
        <li>{ponuda && ponuda.datum}</li>
        <li>{ponuda && ponuda.imeFizickogLica}</li>
        <li>{ponuda && ponuda.kontaktFizickogLica}</li>
      </ul>

      <label>Poruka</label>
      <textarea
        type="text"
        id="porukaInput"
        readOnly={true}
        value={ponuda && ponuda.poruka}
      />
      <label>Odgovor</label>
      <textarea
        type="text"
        id="odogovorInput"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        label={formik.values.porukaInput}
      />
      {formik.touched.odogovorInput && formik.errors.odogovorInput ? (
        <span className="input-error" id="odogovorInput-error">
          {formik.errors.odogovorInput}
        </span>
      ) : null}
      <label htmlFor="cijenaInput">Cijena</label>
      <div style={{ display: "flex", alignItems: "center" }}>
        <input
          type="text"
          id="cijenaInput"
          value={cijena}
          onBlur={formik.handleBlur}
          onChange={(e) => {
            formik.handleChange(e);
            setCijena(e.target.value);
          }}
          style={{ width: "200px", marginRight: "10px" }}
        />
        <span style={{ fontSize: "24px" }}>KM</span>
      </div>
      {formik.touched.cijenaInput && formik.errors.cijenaInput ? (
        <span className="input-error" id="cijenaInput-error">
          {formik.errors.cijenaInput}
        </span>
      ) : null}
      <Button type="submit" value="OK" btnType="submit"></Button>
    </form>
  );
}

export default KontaktPravnogLica;
